<template>
  <nav aria-label="Breadcrumb" class="text-base whitespace-nowrap my-3 lg:mt-0 breadcrumb">
    <ul class="flex flex-wrap items-start justify-start breadcrumb-list">
      <li
        v-for="(item, index) in items"
        :key="index"
        class="flex items-center text-gray-900"
      >
        <NuxtLink
          external
          :to="item.href || route?.fullPath"
          :class="[linkClasses,!item.href && 'cursor-pointer']"
          :id="`${breadcrumbId}-${index}`"
          :tabindex="0"
          :title="item.label"
          :aria-current="index === items.length - 1 ? 'page' : undefined"
        >
          {{ item.label }}
        </NuxtLink>
        <span
          aria-hidden="true"
          v-if="index < items.length - 1"
          class="text-gray-900 select-none"
        >/</span>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { useRoute } from 'vue-router'
const route = useRoute()

export interface BreadcrumbItem {
  label: string
  href?: string
}

const props = defineProps<{ 
  items: BreadcrumbItem[],
  id?:string 
  }>()

const linkClasses = computed(() => [
  "flex items-center justify-center px-2",
  "text-gray-700 font-normal"
])

const breadcrumbId = computed(() => props.id || "bread-crumb-id")
</script>
